"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.designToolLabel = exports.AI_LENGTH_MAX_CHARS = exports.AI_LENGTH_MAX_WORDS = exports.AI_LENGTH_TARGETS = exports.DEFAULT_AI_LENGTH_GUIDELINES = void 0;
exports.resolveAiLengthTargetId = resolveAiLengthTargetId;
const enums_1 = require("./enums");
/**
 * Recommended defaults, per the agreed platform guidance. Seeded for a fresh install and used
 * as the merge base on read, so a stored blob that predates a newly-added destination (or omits
 * a field) still resolves to a complete set.
 */
exports.DEFAULT_AI_LENGTH_GUIDELINES = {
    FACEBOOK: { targetWords: 75, targetChars: null, maxChars: null },
    LINKEDIN: { targetWords: 225, targetChars: null, maxChars: null },
    INSTAGRAM: { targetWords: 175, targetChars: null, maxChars: null },
    BLOG: { targetWords: 1500, targetChars: null, maxChars: null },
    X: { targetWords: null, targetChars: 150, maxChars: 280 },
    THREADS: { targetWords: 80, targetChars: null, maxChars: 500 },
};
/** Display order + labels for the App Settings card (matches the guidance as written). */
exports.AI_LENGTH_TARGETS = [
    { id: 'FACEBOOK', label: 'Facebook' },
    { id: 'LINKEDIN', label: 'LinkedIn' },
    { id: 'INSTAGRAM', label: 'Instagram' },
    { id: 'BLOG', label: 'Blog' },
    { id: 'X', label: 'X' },
    { id: 'THREADS', label: 'Threads' },
];
/** Upper bounds accepted on write — generous, but keep a typo from becoming a 9-digit target. */
exports.AI_LENGTH_MAX_WORDS = 20_000;
exports.AI_LENGTH_MAX_CHARS = 100_000;
/**
 * Which length guidance applies to a post, from its channel + platform. Shared so the API's
 * prompt builder and any UI preview can never disagree. Returns null when no guidance is
 * defined for the destination (VIDEO/PODCAST, YouTube Shorts, or a social post with no platform
 * chosen yet) — callers then generate without a length constraint.
 */
function resolveAiLengthTargetId(channel, platform) {
    if (channel === enums_1.ContentChannel.BLOG)
        return 'BLOG';
    if (channel !== enums_1.ContentChannel.SOCIAL)
        return null;
    switch (platform) {
        case enums_1.SocialPlatform.FACEBOOK:
            return 'FACEBOOK';
        case enums_1.SocialPlatform.LINKEDIN:
            return 'LINKEDIN';
        case enums_1.SocialPlatform.INSTAGRAM:
            return 'INSTAGRAM';
        case enums_1.SocialPlatform.X:
            return 'X';
        case enums_1.SocialPlatform.THREADS:
            return 'THREADS';
        default:
            return null;
    }
}
/** Display label for a design tool, used in the `[Add from …]` / `[Import from …]` buttons. */
exports.designToolLabel = {
    canva: 'Canva',
    figma: 'Figma',
};
//# sourceMappingURL=platform-settings.js.map